import { render, staticRenderFns } from "./placard_withdraw.vue?vue&type=template&id=5ca4c310&scoped=true"
import script from "./placard_withdraw.vue?vue&type=script&lang=js"
export * from "./placard_withdraw.vue?vue&type=script&lang=js"
import style0 from "./placard_withdraw.vue?vue&type=style&index=0&id=5ca4c310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca4c310",
  null
  
)

export default component.exports